import { taskApi } from 'api';

export const sendRedistributeDocumentsToApi = async (items: string[], brId: string | undefined) => {
  return await taskApi.redistributeDocumentList({
    brId: brId ?? '',
    documentRedistributionRequest: { idList: items },
  });
};
